import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import clsx from 'clsx';

const overrideStyle = makeStyles((theme) => ({
    title: {
      color: theme.palette.text.secondary
    },
    text: {
      lineHeight: "inherit"
    }
  }), {name: "RaymanText"});

export default function RaymanText({className = null, title = "", children, ...props})
{
    const classes = overrideStyle();
    
    if(title)
    {
        return <h1 className={clsx(classes.title, className)} {...props}>{children}</h1>
    }
    else return <Typography className={clsx(classes.text, className)} {...props}>{children}</Typography>
}